<template>
	<div class="t-productArticle">

		<div class="wrap">
				<div class="calculation-size">
				<h6>How to measure feet?</h6>
				<div class="content">
					<!-- {{contact.measurement}} -->
					<p>Putting your feet on one piece of paper and try hard to the ground.Drawing a line of the widest point of left and right,the longest point of front and back.Remember to measure two feet and take the maximum.The measurement of foot circumference is based on the vertical width on both sides of feet to decide Average version or Wide version.Measure around the widest part of the instep to get an accurate foot circumference.The best measurement time is at dusk or after exercise because the feet are in a fully stretched state due to congestion and prolonged standing. To better understand this method, please check tutorial video. </p>
				</div>
			</div>
			
			<button class="return" @click="$router.go(-1)">
				Back
			</button>
		</div>
		<el-dialog title="Video for feet measurement" :visible.sync="dialogVideoVisible" width="600px">
			<video :src="contact.video" width="100%" controls=""></video>
		</el-dialog>



	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex';

	export default {
		name: "article",
		data() {
			return {
			   dialogTestVisible:false,
               dialogVideoVisible: false,
               long: 0,
			   wide: 0,
			   recommendata: {},
			}
		},
		computed: {
			...mapState({
				contact: state => state.contact,

			}),
		},
		mounted() {
            
		},
		methods: {
            recommend() {
				var data = {
					long: this.long,
					wide: this.wide,
				}
				var that = this;

				this.$api("index/getCalculate", data).then(res => {
					that.recommendata = res.data;
				})
			},


		}

	}
</script>


<style lang="less">
  


	.t-productArticle {

        margin-top:96px;
		min-height:calc(100vh - 150px);

		.wrap {
			width: 900px;
			margin: 0 auto;
			padding-bottom:10%;
            
            .item-shop{

            }
			.return {
				background: #90c31f;
				font-size: 14px;
				color: #fff;
				line-height: 50px;
				margin-top: 30px;
				width: 250px;
				text-align: center;
				display: block;
			}

			h6 {
				font-size: 24px;
				padding-top: 50px;
				font-weight: bold;
				margin-bottom: 3%;
			}

			.content {
				line-height: 1.6;
				font-size: 16px;
				padding: 50px 0;
				min-height: 30vh;
				color: #333333;
				border-top: 1px solid #dcdddd;
				border-bottom: 1px solid #dcdddd;

				h5 {
					text-align: center;
					font-size: 24px;
					font-weight: bold;
					line-height: 4;
				}
			}
		}
	}

	@media screen and (max-width:768px) {
		.t-productArticle{
			min-height: calc(100vh - 100px);
		}
		.t-productArticle{
	        .wrap{
                width:94%;
                h6{
                	font-size:16px;
                	padding-top: 20px;
                }
                .content{
                	padding:20px 0;
                }
			}
		} 
	}
</style>



// WEBPACK FOOTER //
// src/pages/product/article.vue